import { useFormState } from 'holistic-resources';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Button from 'components/Button';
import SectionLabelWithIcon from 'components/typography/SectionLabelWithIcon';
import { ReactComponent as Message } from 'images/icons/message.svg';
import {
  showErrorFeedbackBar,
  showSuccessFeedbackBar,
} from 'reducers/ui/uiSlice';
import { contactAgent, getAssigneeId } from 'services/QuoteLinkService';
import { ACCESS_TOKEN } from 'shared/constants/appConfig';
import { CONTACT_TYPE } from 'shared/constants/common';
import { getValue } from 'shared/helpers/common';
import ContactAgentButton from './ContactAgentButton';

const getTaskTitle = (contactType) => {
  switch (contactType) {
    case CONTACT_TYPE.BOOK:
      return 'I want to book';
    case CONTACT_TYPE.MORE_INFO:
      return 'I need more information';
    case CONTACT_TYPE.NOT_INTERESTED:
      return "I'm not interested";
    default:
      return '';
  }
};

export default function ContactAgent({
  className = '',
  visitorLongId = '',
  contactType,
  updateContactType,
}) {
  const { quoteId } = useParams();
  const dispatch = useDispatch();
  const { theme } = useSelector((state) => state.ui);

  const { formValue, formChangeHandler, setFormValue } = useFormState({
    content: '',
  });

  const resetForm = () => {
    setFormValue({
      content: '',
    });
  };

  const handleSubmit = async () => {
    try {
      const accessToken = ACCESS_TOKEN;
      const assigneeId = await getAssigneeId(quoteId, accessToken);
      const payload = {
        type: 'enquiry',
        context: 'QuoteOverview',
        tags: {
          title: getTaskTitle(contactType),
          description: formValue.content,
        },
        assigneeId: getValue(assigneeId?.data?.author?.id, null),
        quoteId: getValue(quoteId, null),
        visitorLongId: getValue(visitorLongId, null),
      };

      await contactAgent(payload, accessToken);

      dispatch(showSuccessFeedbackBar('Message successfully sent.'));
      resetForm();
    } catch (error) {
      console.error(error);
      dispatch(
        showErrorFeedbackBar('Something went wrong. Failed to send message.'),
      );
    }
  };

  return (
    <div className={className} id="contactAgent">
      <SectionLabelWithIcon
        label="What do you want to do next?"
        icon={<Message />}
        iconContainerClassName="section-icon"
      />
      <div className="flex flex-col gap-4 md:flex-row mt-[40px]">
        <ContactAgentButton
          isSelected={contactType === CONTACT_TYPE.BOOK}
          label="I want to book"
          onClick={() => updateContactType(CONTACT_TYPE.BOOK)}
        />
        <ContactAgentButton
          isSelected={contactType === CONTACT_TYPE.MORE_INFO}
          label="I need more information"
          onClick={() => updateContactType(CONTACT_TYPE.MORE_INFO)}
        />
        <ContactAgentButton
          isSelected={contactType === CONTACT_TYPE.NOT_INTERESTED}
          label="I'm not interested"
          onClick={() => updateContactType(CONTACT_TYPE.NOT_INTERESTED)}
        />
      </div>
      <textarea
        name="content"
        value={formValue.content}
        className="p-4 my-4 w-full h-[12rem] border border-secondary rounded-lg"
        style={{ borderColor: theme.brandColour }}
        onChange={formChangeHandler}
        placeholder="Type your message here"
      />
      <div className="flex justify-center">
        <Button
          label="Send to your travel specialist"
          className="w-full xs:w-[283px] [@media(hover:hover){&:hover}]:underline"
          onClick={handleSubmit}
        />
      </div>
    </div>
  );
}
